var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"z-index":"0","position":"fixed","width":"100%","height":"100%","left":"0px","top":"0px","background":"rgba(0, 0, 0, 1)","opacity":"0"},attrs:{"id":"shadow-container"}})
}
var staticRenderFns = []

export { render, staticRenderFns }